import { createSelector } from 'reselect'

import { selectEmrVersionConfig } from 'selectors/selectEmrVersionConfig'

export const selectDefaultInstances = createSelector([selectEmrVersionConfig], (emrVersionConfig) =>
  emrVersionConfig.get('default_ondemand_instances')
)
